import React from 'react'
import Update from '../update'

export default function RemoveRows () {
  return (
    <Update isDelete={true} />
  )
}
